import type { ILeitnerLevelBucket } from './leitner-level-buckets';

export type IProgressCardBucketFilter = 'all' | ILeitnerLevelBucket;

export const PROGRESS_CARD_BUCKET_FILTERS: readonly IProgressCardBucketFilter[] = [
  'all',
  'new',
  'learning',
  'strong',
  'mastered',
];

export type IProgressCardStateFilter = 'all' | 'due' | 'struggling' | 'never';

export const PROGRESS_CARD_STATE_FILTERS: readonly IProgressCardStateFilter[] = [
  'all',
  'due',
  'struggling',
  'never',
];
